var _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGlovo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.6c-6.8 0-12.4 5.5-12.4 12.2 0 2.6.8 5 2.3 7.1l.3.5 6.5 9s.8 1.3 2.5 1.3h1.5c1.7 0 2.5-1.3 2.5-1.3l6.5-9 .3-.5c1.5-2.1 2.3-4.6 2.3-7.1.1-6.7-5.5-12.2-12.3-12.2zm5.1 15.8l-.3.5-4.8 6.6-4.8-6.6-.3-.5c-.8-1-1.2-2.3-1.2-3.6 0-3.4 2.8-6.2 6.3-6.2s6.3 2.8 6.3 6.2c0 1.3-.4 2.5-1.2 3.6zm-8.6 19.7c0-1.8 1.5-3.4 3.5-3.4s3.4 1.5 3.4 3.3c0 1.8-1.5 3.3-3.5 3.3-1.9.1-3.4-1.4-3.4-3.2z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#5D574C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlovo);
export default __webpack_public_path__ + "static/media/glovo.6926c5769e4edbdb60e9c935d909cdac.svg";
export { ForwardRef as ReactComponent };